import React from "react";
import "./Sidebar.css";
import { Tooltip, Typography } from "@mui/material";

// TopScoresSidebar displays the top 5 artistic and technical scores (no overlap)
// for routines the judge has already scored, filtered by the same level and size as the current entry.
function TopScoresSidebar({ scoreData, rowIndex, colIndexes, judgeResponses, judgeColIndexes }) {
  const { titleIdx, choreoIdx, levelIdx, sizeIdx } = colIndexes;
  const { entryIdx, artisticIdx, technicalIdx, notesIdx } = judgeColIndexes;
  // Get current entry's level and size
  const currentLevel = scoreData[rowIndex]?.[levelIdx] || "";
  const currentSize = scoreData[rowIndex]?.[sizeIdx] || "";

  // Always derive userScores from judgeResponses (never cache)
  // Use useMemo to ensure recalculation on every judgeResponses or rowIndex change
  // const userScores = useMemo(() => {
  //   const scores = {};
  //   if (judgeResponses && judgeResponses.length > 1) {
  //     judgeResponses.slice(1).forEach(row => {
  //       const entryNum = row[entryIdx]; // Assuming entry number is in the second column (index 1)
  //       const artistic = row[artisticIdx]; // Assuming artistic score is in the third column (index 2)
  //       const technical = row[technicalIdx]; // Assuming technical score is in the fourth column (index 3)
  //       scores[entryNum] = artistic && technical ? `${artistic}/${technical}` : (artistic || technical || "-");
  //     });
  //   }
  //   return scores;
  // }, [judgeResponses, rowIndex]);

  // Defensive: don't render if missing data
  // if (!userScores || !scoreData || scoreData.length < 2 || rowIndex < 1) return null;


  // Build a list of scored entries with matching level/size from judge response rows.
  const scoredEntries = (judgeResponses || [])
    .slice(1)
    .map((respRow) => {
      const entryNum = respRow?.[entryIdx];
      if (entryNum === undefined || entryNum === null || entryNum === "") return null;

      const idx = scoreData.findIndex((row, i) => i > 0 && String(row[0]) === String(entryNum));
      if (idx === -1) return null;

      const scoreRow = scoreData[idx];
      if (scoreRow[levelIdx] !== currentLevel || scoreRow[sizeIdx] !== currentSize || scoreRow[choreoIdx].toLowerCase() === 'teacher') return null;

      const artisticRaw = respRow?.[artisticIdx];
      const technicalRaw = respRow?.[technicalIdx];
      const artistic = artisticRaw === "" || artisticRaw == null ? null : Number(artisticRaw);
      const technical = technicalRaw === "" || technicalRaw == null ? null : Number(technicalRaw);

      return {
        entryNum,
        artistic: Number.isFinite(artistic) ? artistic : null,
        technical: Number.isFinite(technical) ? technical : null,
        notes: respRow?.[notesIdx] || "",
        title: scoreRow[titleIdx] || scoreRow[1] || "",
      };
    })
    .filter((e) => e && (e.artistic != null || e.technical != null));

  // Calculate top 5 average scored routines (average of artistic and technical)
  const topAverage = [...scoredEntries]
    .filter(e => e.artistic != null && e.technical != null)
    .map(e => ({
      ...e,
      average: (Number(e.artistic) + Number(e.technical)) / 2
    }))
    .sort((a, b) => b.average - a.average)
    .slice(0, 5);

  return (
    <div className="ossdf-sidebar">
      <Typography variant="h1" color="primary" sx={{ marginBottom: 0.5 }}>High Score Tracking</Typography>
      <Typography variant="h3" color="text" sx={{ marginBottom: 1.5 }}>
        {currentLevel} {currentSize ? `- ${currentSize}` : ""}
      </Typography>
      {topAverage.length === 0 ? <div style={{ color: '#888' }}>No averages yet for this level/size.</div> :
        <ol style={{ paddingLeft: 18, lineHeight: 1.1, margin: 0, fontSize: '0.95em' }}>
          {topAverage.map(e => (
            <Tooltip key={e.entryNum} title={`${e.notes !== "" ? e.notes : "N/A"}`}
              arrow
              placement="right"
            >
              <li key={e.entryNum} style={{ marginBottom: 8 }}>
                <b>Entry #{e.entryNum}</b>: {e.title}
                <div style={{ display: 'flex', gap: 16, marginTop: 2, marginLeft: 40 }}>
                  <Typography variant="numbers" color='#1976d2' fontWeight="bold"> A: {Number(e.artistic).toFixed(2)}</Typography>
                  <Typography variant="numbers" color='#3da342' fontWeight="bold"> T: {Number(e.technical).toFixed(2)}</Typography>
                </div>
              </li>
            </Tooltip>
          ))}
        </ol>
      }
    </div>
  );
}

export default TopScoresSidebar;
